/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateTaskTemplateRequest} from '@cash-web/protos/squareup/stafftasks/endpoints/update-task-template.pb'
import {UpdateTaskTemplateResponse} from '@cash-web/protos/squareup/stafftasks/endpoints/update-task-template.pb'


export const updateTaskTemplate = (request: UpdateTaskTemplateRequest, options?: CashRequestOptions) => post<UpdateTaskTemplateRequest, UpdateTaskTemplateResponse>("/proxy/services/squareup.stafftasks.service.StaffTasksService/UpdateTaskTemplate", request, {...options, rejectOnError: true })